import {
  Box,
  Text,
  Button,
  Flex,
} from "@chakra-ui/react";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";

export default function SurveyEnd() {
  const navigate = useNavigate();

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black" letterSpacing="wide">
          RESOURCES
        </Text>
      </Box>

      {/* Responsive Main Content */}
      <Box
        flex="1"
        display="flex"
        justifyContent="center"
        px={4}
        py={6}
        overflowY="auto"
      >
        <Box width="100%" maxW="420px">

          {/* Survey Title */}
          <Text fontWeight="bold" fontSize="xl" color="black" mb={2} textAlign={"center"}>
            Small Business Assistance Application Survey
          </Text>


          {/* Custom Progress Bar */}
          <Box
            width="100%"
            maxW="360px"
            mx="auto"
            mb={10}
            height="28px"
            border="2px solid black"
            borderRadius="full"
            overflow="hidden"
          >
            <Box
              width="100%"
              height="100%"
              bg="#00C49A"
              borderRightRadius="full"
            />
          </Box>

          {/* Question */}
          <Text
            fontWeight="bold"
            fontSize="lg"
            mb={6}
            textAlign="center"
            px={2}
            textDecoration="none"
          >
            Thank you! Your responses has been recorded!
          </Text>
        </Box>
      </Box>

      {/* Footer Navigation Buttons */}
      <Flex
        justifyContent="space-between"
        align="center"
        px={6}
        position="absolute"
        bottom="80px"
        width="100%"
      >
        <Button
          variant="ghost"
          leftIcon={<FaArrowLeft color="#00C49A" />}
          color="black"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
        <Button
          variant="ghost"
          onClick={() => navigate("/Resources")}
          rightIcon={<FaArrowRight color="#00C49A" />}
          color="black"
        >
          Go to Resource Home
        </Button>
      </Flex>

      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      >
      </Flex>
    </Box>
  );
}
